import axios from '../utils/axios';

export const addClassToBody = className => {
  const body = document.body;

  if (!body.classList.contains(className)) {
    body.classList.add(className);
  }
};

export const removeClassFromBody = className => {
  const body = document.body;

  if (body.classList.contains(className)) {
    body.classList.remove(className);
  }
};

export const setAuthToken = token => {
  if (token) {
    // Apply to every request
    axios.defaults.headers.common['Authorization'] = `Token ${token}`;
  } else {
    // Delete Auth header
    delete axios.defaults.headers.common['Authorization'];
  }
};

export const objectIsEmpty = object => (Object.keys(object).length > 0);


// WEBPACK FOOTER //
// ./src/utils/utils.js